import { useTrackingEventsDatas } from "./useTracking";
import { useTrackingEvent } from "./useTrackingEvent";
export const useTrackingBookVisit = (av_zone) => {
    const EVENT_DATA = {
        event: "lead_classified_form_opened",
        av_zone,
        av_category: "classified",
        av_feature: "book_a_visit",
        ...useTrackingEventsDatas({
            av_zone,
            displayMedium: true,
        }),
    };
    return useTrackingEvent(EVENT_DATA);
};
